"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var adyen_tokenization_1 = require("./adyen_tokenization");
var api_request_1 = require("../components/api_request");
var user_store_1 = require("../reverb-js-common/user_store");
var url_helpers_1 = require("../components/shared/url_helpers");
var browser_info_1 = require("./browser_info");
function mapLegacyTokenizedCard(creditCardInput) {
    return {
        adyen_token: adyen_tokenization_1.default.tokenizeCard({
            number: creditCardInput.cardNumber,
            cvc: creditCardInput.cvv,
            holderName: creditCardInput.cardholderName,
            expiryMonth: creditCardInput.expirationMonth,
            expiryYear: creditCardInput.expirationYear,
        }),
    };
}
function mapCreditCardCreateParams(creditCardInput, tokenizedFields) {
    if (shouldUseAdyenCheckoutAPI()) {
        return { adyen_token: tokenizedFields };
    }
    return mapLegacyTokenizedCard(creditCardInput);
}
function mapCreditCardUpdateParams(creditCardInput) {
    if (shouldUseAdyenCheckoutAPIForUpdates()) {
        return {
            expiration_month: creditCardInput.expirationMonth,
            expiration_year: creditCardInput.expirationYear,
        };
    }
    return mapLegacyTokenizedCard(creditCardInput);
}
function shouldUseAdyenCheckoutAPI() {
    return true; // adyen_checkout_api_vaulting rollout is at 100%. Here for Core compat
}
exports.shouldUseAdyenCheckoutAPI = shouldUseAdyenCheckoutAPI;
exports.ADYEN_CHECKOUT_API_CARD_UPDATES = 'adyen_checkout_api_card_updates';
function shouldUseAdyenCheckoutAPIForUpdates() {
    return user_store_1.default.isExperimentEnabled(exports.ADYEN_CHECKOUT_API_CARD_UPDATES);
}
exports.shouldUseAdyenCheckoutAPIForUpdates = shouldUseAdyenCheckoutAPIForUpdates;
function saveCreditCard(creditCardInput, tokenizedFields, billingAddressInput) {
    var commonParams = {
        browser_info: browser_info_1.browserInfo(),
        channel: 'web',
        billing_address: {
            street_address: billingAddressInput.streetAddress,
            extended_address: billingAddressInput.extendedAddress,
            locality: billingAddressInput.locality,
            region: billingAddressInput.region,
            postal_code: billingAddressInput.postalCode,
            country_code: billingAddressInput.countryCode,
        },
        cardholder_name: creditCardInput.cardholderName,
    };
    var isCreate = !creditCardInput.id;
    if (isCreate) {
        return api_request_1.default.V3.post(url_helpers_1.default.myCreditCardsCreatePath(), tslib_1.__assign(tslib_1.__assign({}, commonParams), mapCreditCardCreateParams(creditCardInput, tokenizedFields)));
    }
    return api_request_1.default.V3.put(url_helpers_1.default.myCreditCardPath(creditCardInput.id), tslib_1.__assign(tslib_1.__assign({}, commonParams), mapCreditCardUpdateParams(creditCardInput)));
}
exports.saveCreditCard = saveCreditCard;
exports.default = saveCreditCard;
//# sourceMappingURL=save_credit_card.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/save_credit_card.js
// module id = Z+od
// module chunks = 20 21